<template>
  <div class="bootstrap-wrapper main">
    <div class="container">
      <div class="row d-flex justify-content-center mt-lg-5 mt-0">
        <div class="col-lg-6 px-lg-5 body rounded">
          <div class="col-12">
            <!-- Images -->
            <div class="d-flex justify-content-between pb-5 pt-5">
              <img class="customLogin-logo"
                src="../../assets/img/posadas-corporate.svg"
                v-bind:alt="$t('language.posadasCorporate.posadasCorporate')"
              />
              <section class="d-flex align-items-center" @click="reloadReCaptcha">
                <Languages />
              </section>
            </div>
            <!-- From -->
            <div class>
              <p
                class="subtitle pb-3"
              >{{ $t('language.posadasCorporate.recuperarPassword.olvidasteContrasena') }}</p>
              <p
                class
              >{{ $t('language.posadasCorporate.recuperarPassword.ingresaDatosContrasenaReestablecida') }}</p>
              <br />
            </div>
            <form @submit.prevent="handleSubmit">
              <div class="form-element">
                <label
                  for="clientId"
                >{{ $t('language.posadasCorporate.recuperarPassword.clienteId') }}*</label>
                <div class>
                  <input
                    type="text"
                    @keydown.space.prevent
                    v-model="user.clientId"
                    id="clientId"
                    name="clientId"
                    class="form-control mayuscula"
                    :class="{ 'is-invalid': submitted && $v.user.clientId.$error || !$v.user.clientId.maxLength }"
                  />
                  <div
                    v-if="submitted && !$v.user.clientId.required"
                    class="invalid-feedback"
                  >{{ $t('language.posadasCorporate.recuperarPassword.clienteIdIncorrecto') }}</div>
                  <span
                    class="invalid-feedback"
                    v-if="!$v.user.clientId.maxLength"
                  >{{ $t('language.posadasCorporate.recuperarPassword.clienteIdNoMayora') }} {{$v.user.clientId.$params.maxLength.max}} {{ $t('language.posadasCorporate.recuperarPassword.caracteres') }}.</span>
                </div>
              </div>
              <div class="form-element">
                <label
                  for="userName"
                >{{ $t('language.posadasCorporate.recuperarPassword.usuario') }}*</label>
                <div class>
                  <input
                    type="text"
                    @keydown.space.prevent
                    v-model="user.userName"
                    id="userName"
                    name="userName"
                    class="form-control minuscula"
                    :class="{ 'is-invalid': submitted && $v.user.userName.$error || !$v.user.userName.maxLength }"
                  />
                  <div
                    v-if="submitted && !$v.user.userName.required"
                    class="invalid-feedback"
                  >{{ $t('language.posadasCorporate.recuperarPassword.nombreUsuarioIncorrecto') }}</div>
                  <span
                    class="invalid-feedback"
                    v-if="!$v.user.userName.maxLength"
                  >{{ $t('language.posadasCorporate.recuperarPassword.nombreDeUsuarioNoMayora') }} {{$v.user.userName.$params.maxLength.max}} {{ $t('language.posadasCorporate.recuperarPassword.caracteres') }}.</span>
                </div>
              </div>
              <div class="pt-4">
                <p
                  class="subtitle"
                >{{ $t('language.posadasCorporate.recuperarPassword.marcaCasilla') }}*</p>
                <div class="col-12 row">
                  <div v-if="banCaptcha" class="g-recaptcha" v-bind:data-sitekey="keyCaptcha"></div>
                </div>
                <div>
                  <p>* {{ $t('language.posadasCorporate.recuperarPassword.todosCamposRequeridos') }}</p>
                </div>
              </div>
              <Loader v-if="banLoaderL"/>
              <div class="row py-5">
                <div class="col-md-6 order-md-1 order-2">
                  <router-link class="subtitle colorBlue" to="/login">
                    <button
                      class="secondary-button"
                    >{{ $t('language.posadasCorporate.recuperarPassword.regresar') }}</button>
                  </router-link>
                </div>
                <div class="col-md-6 order-md-2 order-1">
                  <button
                    :disabled="isDisabled || banLoaderL"
                    class="mb-md-0 mb-3"
                  >{{ $t("language.posadasCorporate.recuperarPassword.enviar") }}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <modal v-show="isModalVisible" @close="closeModal" maxWidth="max-w-500">
      <template slot="header">
        <b :class="modalClass"><!-- verde - caution - tituloModal -->
          <i v-if="modalClass==='verde'" class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          <i v-if="modalClass==='caution'" class="demo-icon icon-warning-fill Fw-bolder"></i>
          <i v-if="modalClass==='danger'" class="icon-close-rounded-fill Fw-bolder"></i>
           {{modalHeader}}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{modalMessage}}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary" @click="closeModal()"
          aria-label="Close modal">
          {{modalFooterBotton}}
        </button>
      </template>
    </modal>

    <modal v-if="banModalDont" @close="closeModalDont" maxWidth="max-w-500">
          <template slot="header">
            <b class="danger"> <i class="icon-close-rounded-fill Fw-bolder"></i> {{$t("language.posadasCorporate.login.WSError")}}</b>
          </template>
          <template slot="body">
            <p class="Ta-left">
              {{$t("language.posadasCorporate.login.textoModal1")}}
            </p>
            <p class="Ta-left">
              
              {{$t("language.posadasCorporate.login.textoModal2")}} <a href='https://api.whatsapp.com/send?phone=5214431378728&text=Hola,%C2%BFMe%20pueden%20ayudar?'>{{$t("language.posadasCorporate.login.textoModal3")}}</a> {{$t("language.posadasCorporate.login.textoModal4")}} <a href='tel:4432982253'>{{$t("language.posadasCorporate.login.textoModal5")}}</a>.
            </p>
          </template>
          <template slot="footer">
            <button type="button" class="button btn-primary" @click="closeModalDont"
              aria-label="Close modal">
              {{$t("language.posadasCorporate.login.entendido")}}
            </button>
          </template>
        </modal>
  </div>
</template>

<script>
import * as GlobalFunctions from "../../utils/GlobalFunctions";
import Languages from "../languages/Languages";
import { required, maxLength } from "vuelidate/lib/validators";
import i18n from "../../plugins/i18n";
import axios from "axios";
import Loader from "../loader/Loader";
import SecureLS from "secure-ls";
import Modal from '../addons/Modal.vue';

export default {
  name: "Password",
  components: {
    Languages,
    Loader,
    Modal
  },
  data: () => {
    return {
      banLoaderL: false,
      banModalDont: false,
      isModalVisible: false,
      ls: new SecureLS({ encodingType: "aes" }),
      banCaptcha: true,
      keyCaptcha: process.env.VUE_APP_KEYCAPTCHA,
      modalHeader: "Header",
      modalMessage: "",
      modalFooterBotton: "Footer",
      modalClass: "class",
      user: {
        clientId: "",
        userName: ""
      },
      submitted: false
    };
  },
  validations: {
    user: {
      clientId: { required, maxLength: maxLength(20) },
      userName: { required, maxLength: maxLength(20) }
    }
  },
  methods: {
    
    closeModalDont(){
      this.banModalDont = false;
      setTimeout(() => {
        this.$router.push({ name: "Login" });
      }, 500);
    },
    openModal(header, message, footer, tipo){
      if (tipo === 1) {
        this.modalClass = 'verde';
      }
      if (tipo === 2) {
        this.modalClass = 'caution';
      }
      if (tipo === 3) {
        this.modalClass = 'danger';
      }
      this.modalHeader = header;
      this.modalMessage = message;
      this.modalFooterBotton = footer;
      setTimeout(() => {
        this.isModalVisible = true;
      }, 1);
    },
    closeModal() {
      this.isModalVisible = false;
      if (this.modalClass === 'verde' || this.modalClass === 'danger') {
        this.$router.push({ name: "Login" });        
      }
    },
    handleSubmit(e) {
      /**
       * Se obtiene la respuesta del captcha en response
       * si la longitud es igual a cero -> no esta verificado
       * si la longitud es mayor a 0 -> esta verificado
       */
      var response = grecaptcha.getResponse();
      if (response.length === 0) {
        //captcha no verificado
        this.openModal(i18n.t("language.posadasCorporate.modales.alertCaptcha.title"), i18n.t("language.posadasCorporate.modales.alertCaptcha.textHtml"), i18n.t("language.posadasCorporate.modales.alertCaptcha.aceptar"), 2);
      } else {
        //captcha verificado
        this.submitted = true;

        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.actualizar(this.user.clientId.toUpperCase(), this.user.userName.toLowerCase());
      }
    },
    actualizar(clientid, username) {
      this.banLoaderL = true;
      var data = {
        profileId: clientid,
        username: username
      };
      var language = this.ls.get("Language");
      var urlServiceResetPass =
        process.env.VUE_APP_HOSTCORPORATEAPI +
        process.env.VUE_APP_CORPORATEAPI +
        process.env.VUE_APP_USER +
        process.env.VUE_APP_RPASS;
      axios({
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Accept-Language": language.data
        },
        method: "post",
        url: urlServiceResetPass,
        data: JSON.stringify(data)
      })
        .then(res => {
          this.banLoaderL = false;
          if (res.status === 200) {
            /**
             * servicio respondio con exito con status 200
             * redirecciona al login
             */
            this.openModal(i18n.t("language.posadasCorporate.modales.alertExito.title1"), res.data.message, i18n.t("language.posadasCorporate.modales.alertExito.aceptar"), 1);
          }
        })
        .catch(error => {
          this.banLoaderL = false;
          if (error.response.status == 409 && error.response.data.errorCode == 'RSP_RESET_PASS_02') {
            this.openModal(i18n.t("language.posadasCorporate.recuperarPassword.modalTitle"), i18n.t("language.posadasCorporate.recuperarPassword.modalBody"), i18n.t("language.posadasCorporate.recuperarPassword.modalButton"), 3);
          } else {
            if (error.response.status == 409 && error.response.data.errorCode == 'RSP_RESET_PASS_01') {
              this.banModalDont = true;
            } else {
              /**
               * servicio no responde o error en la petición
               * Modal de error de comunicación o error de petición
               */
              var mensaje = "";
              let errorObject=JSON.parse(JSON.stringify(error));
              if(errorObject.message == 'Network Error' || ( error.response.status < 600 && error.response.status > 403 ) || ( error.response.status < 399 && error.response.status > 299  ) ||  error.response.status < 200   ) {
                this.$router.push({ name: "Error" });
              } else {
                mensaje = error.response.data.message;
              }
            }
          }
        });
    },
    reloadReCaptcha() {
      var language = this.ls.get("Language");
      this.banCaptcha = false;
      setTimeout(() => {
        this.banCaptcha = true;
        this.language(language.data);
      }, 1);
    },
    language(lan) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.async = true;
        script.src = process.env.VUE_APP_APICAPTCHA + '?hl=' + lan;
        document.head.appendChild(script);
      });
    },
  },
  beforeMount() {
    /**
     * Funcion que carga la api de google para el captcha
     */
    const language = this.ls.get("Language");
    this.language(language.data);

    GlobalFunctions.tokenExistValidate().then(response => {
        if(response){
          this.$router.push({ name: "Reservaciones" });                
        }
    });
  },
  computed: {
    isDisabled() {
      if (
        this.user.clientId.length > 1
        && this.user.userName.length > 1
        && this.$v.user.userName.maxLength
        && this.$v.user.clientId.maxLength
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.imgCaptcha {
  width: 32px;
  height: 32px;
}

/* Elementos */
.modal__header {
  position: relative;
  max-width: 100%;
  margin: 0 0 0.4em;
  padding: 0;
  color: #595959;
  text-transform: none;
  word-wrap: break-word;
  font-size: 18px !important;
  margin-bottom: 15px;
  margin-top: 20px;
}

.modal__contenido {
  z-index: 1;
  justify-content: center;
  margin: 0;
  padding: 0;
  margin-bottom: 30px;
  color: #545454;
  font-size: 1.125em;
  font-weight: 300;
  line-height: normal;
  word-wrap: break-word;
}
.minuscula {
  text-transform: lowercase;
}
.modal__footer {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-end !important;
  flex-wrap: wrap !important;
  position: relative !important;
  bottom: 0 !important;
  left: auto !important;
  right: 0 !important;
  padding: 8px 16px 8px 16px !important;
  border-top: 1px solid #e7e8e9 !important;
}

</style>
